var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPretestSelectedCu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Pretest - Selected",
    clipPath: "url(#clip0_2107_31629)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path 6227",
    d: "M0.975586 8.00095V3.31803C0.975586 2.69703 1.22228 2.10147 1.66138 1.66236C2.10049 1.22325 2.69605 0.976563 3.31705 0.976562H12.6829C13.3039 0.976563 13.8995 1.22325 14.3386 1.66236C14.7777 2.10147 15.0244 2.69703 15.0244 3.31803V12.6839C15.0244 13.3049 14.7777 13.9004 14.3386 14.3395C13.8995 14.7787 13.3039 15.0253 12.6829 15.0253H3.31705C2.69605 15.0253 2.10049 14.7787 1.66138 14.3395C1.22228 13.9004 0.975586 13.3049 0.975586 12.6839V11.0819H3.62339",
    stroke: "#EE5294",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 1",
    d: "M10.3317 6.68033C10.3321 6.37284 10.2719 6.06829 10.1546 5.78407C10.0373 5.49984 9.86513 5.2415 9.64798 5.02381C9.43082 4.80611 9.17292 4.63332 8.88899 4.51529C8.60505 4.39727 8.30066 4.33632 7.99317 4.33594C7.68569 4.33555 7.38113 4.39574 7.09691 4.51305C6.81268 4.63037 6.55435 4.80252 6.33665 5.01967C6.11895 5.23682 5.94616 5.49473 5.82813 5.77866C5.71011 6.06259 5.64916 6.36699 5.64878 6.67448C5.64663 7.06256 5.73734 7.44552 5.91333 7.7914C6.08933 8.13729 6.34551 8.43605 6.66049 8.66277V9.18374C6.65958 9.24242 6.67025 9.30071 6.69187 9.35527C6.7135 9.40982 6.74566 9.45959 6.78652 9.50172C6.82737 9.54384 6.87613 9.57751 6.93001 9.60079C6.98388 9.62407 7.04181 9.63651 7.10049 9.6374H8.88098C8.93966 9.63651 8.99759 9.62407 9.05146 9.60079C9.10533 9.57751 9.15409 9.54384 9.19495 9.50172C9.23581 9.45959 9.26797 9.40982 9.28959 9.35527C9.31121 9.30071 9.32188 9.24242 9.32098 9.18374V8.66277C9.63502 8.43658 9.89056 8.13871 10.0664 7.79392C10.2421 7.44912 10.3331 7.06735 10.3317 6.68033Z",
    stroke: "#EE5294",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 3",
    d: "M8.71026 11.6328H7.26929",
    stroke: "#EE5294",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2107_31629"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPretestSelectedCu);
export default __webpack_public_path__ + "static/media/icon-pretest-selected-cu.20b48788f9d9ca98ed6ad9fefcbf5669.svg";
export { ForwardRef as ReactComponent };